import { render, staticRenderFns } from "./AdminCorpProfile.vue?vue&type=template&id=48e62dc4&scoped=true"
import script from "./AdminCorpProfile.vue?vue&type=script&lang=js"
export * from "./AdminCorpProfile.vue?vue&type=script&lang=js"
import style0 from "./AdminCorpProfile.vue?vue&type=style&index=0&id=48e62dc4&prod&scoped=true&lang=css"
import style1 from "./AdminCorpProfile.vue?vue&type=style&index=1&id=48e62dc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e62dc4",
  null
  
)

export default component.exports